attachEvent('.teams-module__item-title', 'click', (e) => {
  if (windowWidth() < breakpointMd) {
    const parentElem = e.target.closest('.teams-module__item');
    const content = parentElem.querySelector('.teams-module__list-wrap');
    parentElem.classList.toggle('is-open');
    slideToggle(content, 300, 'block');
  }
});
